module.exports = {"TXTCLI_Share_link":{"id":"TXTCLI_Share_link","defaultMessage":"Compartir vínculo","track":"Share link"}}